import { useState, useEffect, useParams, useNavigate, useDispatch, titleToUrl, useSelector, HOLIBGTHEME } from "../../imports/generalImport";
import { Box, Container } from "../../imports/muiImport";
import { christmasProductDetailBG1, christmasProductDetailBG2 } from "../../imports/generalImport";
import { createDenominationData, fetchProductById, isDenominationAvailable, isProductLive, validateOutOfStock } from './productDetailHook';

// components
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import GiftCardSectionSkeleton from './GiftCardSectionSkeleton';
import ProductDetailCard from './productUtils/ProductDetailCard';
import ProductDetailTabView from './productUtils/ProductDetailTabView';
import { setProductDetails, wipeOutProductDetails } from '../../store/productInfo/action';
import { setNewDenomination, wipeOutDenomination } from '../../store/productDetails/action';
import { Helmet } from 'react-helmet-async';
import ThreeGiftCard from '../DASHBOARD/ThreeGiftCard';
import PageNotFound from '../OTHERPAGE/PageNotFound';
import ProductSuggestionCard from "../../components/productSuggestion/ProductSuggestionCard";
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn";



function ProductDetail() {
    // States Initialize
    const [productDetail, setProductDetail] = useState([]);  // store current product details
    const [outOfStock, setOutOfStock] = useState(null);  // verify and set this products is out of stock
    const [rangeDenomination, setRangeDenomination] = useState(false); // set range field or not'
    const [productFound, setProductFound] = useState(false);
    const [cpId, setCPId] = useState(0);
    let { title: urlTitle, id: urlId } = useParams();
    const canonicalUrl = `https://www.99gift.in/card-details/${urlId}/${titleToUrl(urlTitle)}`;
    const [pageLoading, setPageLoading] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        // check to product is available or not
        if (urlId != cpId) {
            dispatch(wipeOutProductDetails()); // clear product Details 
            getProductByTitle(urlId, urlTitle);
            dispatch(wipeOutDenomination()); // clear previous denomination
            setCPId(urlId);
        } else {
            // Redirect to home page
            navigate('/');
        }
    }, [urlId, urlTitle]);

    if (productFound) {
        return (<PageNotFound />);
    }

    return (
        <>
            <Helmet>
                <title>
                    {productDetail?.['metaSEO']?.['metaTitle'] ?
                        (productDetail?.['metaSEO']?.['metaTitle']) :
                        (`Buy ${urlTitle} - 99gift.in`)
                    }
                </title>

                <meta
                    property="og:title"
                    content={
                        productDetail?.['metaSEO']?.['metaOGTitle'] ?
                            (productDetail?.['metaSEO']?.['metaOGTitle']) :
                            (`Buy ${urlTitle} - 99gift.in`)
                    }
                />

                <meta
                    name="description"
                    content={
                        productDetail?.['metaSEO']?.['metaDescription'] ?
                            (productDetail?.['metaSEO']?.['metaDescription']) :
                            (`Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`)
                    }
                />

                <meta
                    name="og:description"
                    content={
                        productDetail?.['metaSEO']?.['metaOGDescription'] ?
                            (productDetail?.['metaSEO']?.['metaOGDescription']) :
                            (`Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`)
                    }
                />

                <meta property="og:url" content={canonicalUrl} />
                <link rel="canonical" href={canonicalUrl} />

                {
                    productDetail?.['metaSchema']
                    &&
                    (
                        <script type="application/ld+json">
                            {productDetail?.['metaSchema']}
                        </script>
                    )
                }

                <meta
                    name="twitter:card"
                    content="summary"
                />
                <meta
                    name="twitter:title"
                    content={productDetail?.['metaSEO']?.['metaTitle']}
                />
                <meta
                    name="twitter:description"
                    content={productDetail?.['metaSEO']?.['metaDescription']}
                />
                <meta
                    name="twitter:image"
                    content={productDetail?.image}
                />
                <meta
                    name="twitter:url"
                    content={canonicalUrl}
                />
            </Helmet>

            <Container
                maxWidth="xl"
                sx={{
                    // backgroundColor: "white.main",
                    px: { xs: 0, sm: 2 },
                }}
            >
                <PageBreadcrumb
                    home="Home"
                    category={productDetail?.category?.title}
                    currentProduct={productDetail?.title}
                />


                <Box
                    sx={{
                        backgroundColor: "transparent",
                        backgroundAttachment: "fixed",
                    }}
                >
                    <ProductDetailCard pageLoading={pageLoading} />

                    <ProductDetailTabView
                        pageLoading={pageLoading}
                        productDetail={productDetail}
                        rangeDenomination={rangeDenomination}
                        outOfStock={outOfStock}
                    />
                </Box>

                {/* {allProducts.length && (<ProductSuggestionCard products={allProducts} />)} */}


                <Box sx={{ pb: 4 }}>
                    {!pageLoading ? (
                        <ThreeGiftCard
                            title="You might be interested in"
                            giftCardData={productDetail.like}
                            mbackgroundColor="transparent"
                            fixSlideView={true}
                            design={{
                                boxShadow: {
                                    sm: 0,
                                    md: 0,
                                },
                            }}
                        />
                    ) :
                        <GiftCardSectionSkeleton />
                    }
                </Box>

            </Container>
        </>
    );


    async function getProductByTitle(urlId, urlTitle) {
        setPageLoading(true);
        try {
            const actualData = await fetchProductById(urlId);
            let mainData = {};

            const validateProductTitleResponse = validateProductTitle(actualData?.data, urlTitle);
            const { productType, discount } = isDiscountedProduct(actualData?.data?.discount, actualData?.data?.cashback_amount);

            if (actualData?.status && validateProductTitleResponse) {
                mainData = actualData?.data;
                setProductDetail(mainData);
                mainData.productType = productType;
                mainData.discount = discount;
                mainData.isCashbackProduct = productType === 'Cashback';


                // Task 1
                /***
                 * Check Product is InStock or OutOf Stock 
                 */
                // first check product is available or not 
                const isProductLiveStatus = isProductLive(mainData.front);
                mainData.outOfStock = isProductLiveStatus


                const apiId = actualData?.data.api_id;
                const front = actualData?.data.front;
                const denom = actualData?.data?.denomination;
                const validateResponse = validateOutOfStock(apiId, front, denom);


                if (validateResponse.outOfStockStatus) {
                    mainData.outOfStock = true;
                }
                if (validateResponse.rangeDenominationStatus) {
                    mainData.rangeDenomination = true;
                }


                // -----------END -----------

                /**
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 */

                // Task 2
                /***
                 * Check product denomination available or not 
                 */
                const isDenoAvailable = isDenominationAvailable(mainData?.["denomination"]);
                if (isDenoAvailable?.isDenominationAvailableStatus) {
                    mainData.rangeDenomination = false;

                    // denomination data set into redux store
                    const newDeno = createDenominationData(mainData);
                    dispatch(setNewDenomination(newDeno));
                } else {
                    mainData.rangeDenomination = true;
                }
                // -----------END -----------
            } else {
                // Invalid Response so redirect to home page
                setProductFound(true);
            }

            dispatch(setProductDetails(mainData));
            setPageLoading(false);
            return null;
        } catch (error) {
            console.error(error);
            console.error("something Went Wrong !");
        }
    }


    function validateProductTitle(actualData, urlTitle) {
        const userGivenTitle = urlTitle.toLowerCase();
        const ourProductTitle = actualData?.title.toLowerCase();
        const ourFinalTitle = titleToUrl(ourProductTitle);

        if (ourFinalTitle === userGivenTitle) {
            setProductFound(false);
            return true;
        } else {
            setProductFound(true);
            return true;
        }
    }
}
export default ProductDetail

